import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'

@observer
export default class extends Component {
  render() {
    const { info } = this.props.store
    const { adv_img_url } = info
    return (
      <Fragment>
        {adv_img_url && (
          <div style={{ marginBottom: 20 }}>
            <img src={adv_img_url} />
          </div>
        )}
      </Fragment>
    )
  }
}
